module.exports = __webpack_public_path__ + "../assets/main-bg-mobile.png";